/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DockerImageResponse
 */
export interface DockerImageResponse {
    /**
     * 
     * @type {string}
     * @memberof DockerImageResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DockerImageResponse
     */
    tag: string;
    /**
     * 
     * @type {string}
     * @memberof DockerImageResponse
     */
    apiUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DockerImageResponse
     */
    createdAt: string;
}

export function DockerImageResponseFromJSON(json: any): DockerImageResponse {
    return DockerImageResponseFromJSONTyped(json, false);
}

export function DockerImageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerImageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'tag': json['tag'],
        'apiUrl': !exists(json, 'api_url') ? undefined : json['api_url'],
        'createdAt': json['created_at'],
    };
}

export function DockerImageResponseToJSON(value?: DockerImageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'tag': value.tag,
        'api_url': value.apiUrl,
        'created_at': value.createdAt,
    };
}

